export const MethodsResourceMapper = {
    post: 'create',
    get: 'read',
    put: 'update',
    patch: 'update',
    delete: 'delete',
};
